import React from "react";
import TopNav from "./top-nav";
import SideNav from "./side-nav";
import BottomTabBar from "./bottom-tab-bar";
import { PageTitle } from "@/components/seo/page-title";

type NavbarLayoutProps = {
  children: React.ReactNode;
};

const NavbarLayout = ({ children }: NavbarLayoutProps) => {
  return (
    <div className="flex h-screen w-full bg-(--color-bg-page) overflow-hidden">
      <PageTitle />
      {/* ── Desktop sidebar ─────────────────────────────────────── */}
      <SideNav />

      {/* ── Main column (top nav + content) ──────────────────────── */}
      <div className="flex-1 flex flex-col min-w-0">
        <TopNav />

        {/* 
          Main content area:
          - pb-14 on mobile to clear the fixed bottom tab bar
          - no extra padding on desktop
        */}
        <main className="flex-1 overflow-y-auto pb-14 md:pb-0 p-4 md:p-6">
          <div className="max-w-300 mx-auto">{children}</div>
        </main>
      </div>

      {/* ── Mobile bottom tab bar ─────────────────────────────────── */}
      <BottomTabBar />
    </div>
  );
};

export default NavbarLayout;
